module.exports = __webpack_public_path__ + "img/rep-steve.f1da79ef.jpg";